function observerWrapper(observer, nextState, dispatch) {
    var actionsToDispatch = [];
    var delayedDispatch = function (action) { return actionsToDispatch.push(action); };
    observer(nextState, delayedDispatch);
    actionsToDispatch.forEach(function (action) { return dispatch(action); });
}
function createObservable(store, observers) {
    function toObservable(observableStore) {
        return {
            subscribe: function (_a) {
                var onNext = _a.onNext;
                var dispose = observableStore.subscribe(function () {
                    return onNext(observableStore.getState(), observableStore.dispatch);
                });
                onNext(observableStore.getState(), observableStore.dispatch);
                return { dispose: dispose };
            }
        };
    }
    var observableStore = toObservable(store);
    observers.forEach(function (observer) {
        observableStore.subscribe({
            onNext: function (nextState, dispatch) { return observerWrapper(observer, nextState, dispatch); }
        });
    });
    return observableStore;
}
export default createObservable;
//# sourceMappingURL=createObservable.js.map